import { NoArticle as NoArticle_filmzi } from './NoArticle.filmzi';
import { NoArticle as NoArticle_kojaro } from './NoArticle.kojaro';
import { NoArticle as NoArticle_pedal } from './NoArticle.pedal';
import { NoArticle as NoArticle_zoomg } from './NoArticle.zoomg';
import { NoArticle as NoArticle_zoomit } from './NoArticle.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return NoArticle_filmzi;

    case 'kojaro':
      return NoArticle_kojaro;

    case 'pedal':
      return NoArticle_pedal;

    case 'zoomg':
      return NoArticle_zoomg;

    default:
      return NoArticle_zoomit;
  }
};

export const NoArticle = IconRenderer();
